// extracted by mini-css-extract-plugin
module.exports = {"editButton":"EditButton_editButton__3mz8h","dark":"EditButton_dark__2zZRX"};